import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import PlayPage from './components/PlayPage';  // Updated import
import SettingsPage from './components/SettingsPage';
import GlobalPage from './components/GlobalPage';
// import netlifyIdentity from 'netlify-identity-widget';
import './styles/App.css';
import './styles/Question.css'; // Add this line
import Typed from 'typed.js'; // Add this line
import { useHotkeys } from 'react-hotkeys-hook'; // Add this line

function App() {
  // const [user, setUser] = useState(null); // Login disabled
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const [hasApiKey, setHasApiKey] = useState(!!localStorage.getItem('openai_api_key'));

  // useEffect(() => {
  //   // Login disabled, keeping for potential future use
  //   if (process.env.REACT_APP_SKIP_AUTH === 'true') {
  //     console.log('Skipping authentication for local development');
  //   } else {
  //     console.log('Auth');
  //     netlifyIdentity.on('login', user => {
  //       setUser(user);
  //       netlifyIdentity.close();
  //     });
  //     netlifyIdentity.on('logout', () => {
  //       setUser(null);
  //       netlifyIdentity.close();
  //     });
  //     if (netlifyIdentity.currentUser()) {
  //       netlifyIdentity.close();
  //     }
  //     setUser(netlifyIdentity.currentUser());
  //   }
  // }, []);

  useEffect(() => {
    const onApiKeyChange = () => setHasApiKey(!!localStorage.getItem('openai_api_key'));
    window.addEventListener('hikemind:api_key_changed', onApiKeyChange);
    window.addEventListener('storage', onApiKeyChange);
    return () => {
      window.removeEventListener('hikemind:api_key_changed', onApiKeyChange);
      window.removeEventListener('storage', onApiKeyChange);
    };
  }, []);

  // const handleLogin = () => {
  //   if (process.env.REACT_APP_SKIP_AUTH === 'true') {
  //     console.log('Skipping authentication for local development');
  //     setUser({ name: 'Local User' }); // Simulate a user login
  //   } else {
  //     netlifyIdentity.open('login');
  //   }
  // };

  // useEffect(() => {
  //   // App-level welcome typing disabled; pages handle their own titles
  //   if (!hasApiKey) return;
  //   const options = {
  //     strings: ["Welcome to Hike Mind"],
  //     typeSpeed: 30,
  //     backSpeed: 50,
  //     loop: false,
  //     showCursor: false,
  //     onComplete: () => {
  //       const button = document.querySelector('.start');
  //       if (button) {
  //         button.style.opacity = '1';
  //         button.focus();
  //       }
  //     }
  //   };
  //   const typed = new Typed(".typed-element", options);
  //   return () => { typed.destroy(); };
  // }, [hasApiKey]);


  // useHotkeys('Enter', (event) => {
  //   if (hasApiKey && !user) {
  //     event.preventDefault();
  //     handleLogin();
  //   }
  // });

  return (
    <Router>
      <div className="App" tabIndex="-1">
        {!hasApiKey ? (
          <Routes>
            <Route path="*" element={<SettingsPage />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/play/:subject" element={<PlayPage />} />  {/* Updated path */}
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/global" element={<GlobalPage />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;